import $ from 'jquery'

export class SolutionProducts {

  constructor($container) {
    this.$container = $container

    // if ($container.hasClass('tabs')) {
    //   this.$container.find('.tabs-nav-item').on('click', this.handleClickTabsNavLink.bind(this))
    //   setTimeout(() => this.handleClickTabsNavLink({target: this.$container.find('[data-tab-link].active')}), 300)
    // }
  }

  handleClickTabsNavLink (e) {
    let hashLink = $(e.target).data(`tab-link`)

    if (this.$container.find(`[data-tab-content="${hashLink}"]`).hasClass('full')) {
      this.$container.find('.solution-products-border').addClass('border-bg')
    } else {
      this.$container.find('.solution-products-border').removeClass('border-bg')
    }
  }
}
